import React from 'react'
import TextInput from './form/TextInput'
import JSONImportInput from './form/JSONImportInput'
import WordImportInput from './form/WordImportInput'

import GlobalStorage from './storage/GlobalStorage'
import AppZipCreator from '../AppZipCreator'
import AppConnector from '../AppConnector'

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      file: null
    }
    this.GS = new GlobalStorage();
    this.handleChange = this.handleChange.bind(this)
  }
  
  handleChange(event) {
    this.setState({
      file: URL.createObjectURL(event.target.files[0])
    })
  }

  doAction(item)
  {
    if (item.is_href)
    {
      this.setState({
        href: item.name,
        item: item,
      })
    }

  }

  render()
  {
    return (
        <div style={{padding:`10px 15px`,position: `relative`, height: `100%`, display: `flex`, flexDirection: `column`}}>
          <h3 style={{margin:`15px 0px`}}>故事名稱</h3>
          <p>
            <label>故事名稱</label>
            <br/>
            <TextInput
                value={this.GS.getStory().storyName}
                onChange={(e) => {
                  this.GS.getStory().storyName = e.target.value;
                  this.forceUpdate();
                }}
            />
          </p>

          <p>
            <label>作者</label>
            <br/>
            <TextInput
                value={this.GS.getStory().author}
                onChange={(e) => {
                  this.GS.getStory().author = e.target.value;
                  this.GS.getStoryEpisode().author = e.target.value;
                  this.forceUpdate();
                }}
            />
          </p>   
          <p>
            <label>故事類別</label>
            <br/>
            <select
                value={this.GS.getStory().category}
                onChange={(e) => {
                  this.GS.getStory().category = e.target.value;
                  this.forceUpdate();
                }}
            >
              <option value={'SCIENCE_FICTION'}>{'科幻'}</option>
              <option value={'HORROR'}>{'恐佈'}</option>
              <option value={'ROMANCE'}>{'愛情'}</option>
              <option value={'COMEDY'}>{'搞笑'}</option>
              <option value={'MYSTERY'}>{'推理'}</option>    
              <option value={'CHINESE_MARTIAL'}>{'武俠'}</option>
            </select>
          </p>      

          <p>
            <label>故事簡介</label>
            <br/>
            <textarea
                value={this.GS.getStory().description}
                onChange={(e) => {
                  this.GS.getStory().description = e.target.value;
                  this.forceUpdate();
                }}
            />
          </p>          
          
          <p>
            <label>故事封面 (1080 x 1920px)</label>
            <br/>
            <input type="file" accept="image/*" id="story-cover-image" name="cover-image" onChange={this.handleChange}/>
            <img style={{maxWidth:'200px'}} src={this.state.file}/>
          </p>
          <div style={{width:'100%'}}>
            <button type="button" class="btn btn-primary btn-sm center-block"
            onClick={(e)=>{
              new AppZipCreator().createStory();              
              this.props.doSwitch('StoryEpisode');            
            }}
            >確認</button>
          </div>
          <div>
            { /*
              this.GS.getUserStory().storyList.content.map((item)=>{
                return (
                  <button className={"btn btn-primary btn-sm center-block"}
                    onClick ={ (e)=>{
                        this.GS.setStory({
                        storyName:item.storyName,
                        author:item.author,
                        description:item.description,
                        category:item.category,
                        uuid:item.uuid
                      });

                      new AppConnector().listStoryEpisode(item.uuid);
                      this.forceUpdate();
                    }}
                  >
                  {item.storyName}
                  </button>
                )
              })
            */
            }
          </div>

        </div>
    )
  }
}